{
  "version": 1,
  "asset_id": "35fc83f6-4614-423a-83da-c89b81d0aa8d",
  "project_id": "ca7587fa-3476-4974-b258-69992cc9166e",
  "url": "/__l5e/assets-v1/35fc83f6-4614-423a-83da-c89b81d0aa8d/badge-beste-koop.png",
  "r2_key": "a/v1/ca7587fa-3476-4974-b258-69992cc9166e/35fc83f6-4614-423a-83da-c89b81d0aa8d/badge-beste-koop.png",
  "original_filename": "badge-beste-koop.png",
  "size": 367853,
  "content_type": "image/png",
  "created_at": "2026-10-19T17:45:03Z"
}
